<template>
  <b-sidebar
    :visible="ticketOpen"
    aria-labelledby="sidebar-no-header-title"
    right
    width="800px"
    backdrop
    lazy
    @hidden="RESET_TICKET"
    class="ticket-card"
  >
    <template #header="{ hide }">
      <h3 ref="SIDEBAR" class="d-flex align-items-center w-100 mb-0 py-2">
        <div class="ticket-card__title mr-auto">{{ ticketTitle }}</div>

        <b-dropdown v-if="isB2BTask" text="Действия" class="ml-3">
          <b-dropdown-item
            v-if="isAdmin"
            :disabled="ticket.get_status.ID === 2"
            @click="setStatusTicket(2)"
            >Перевести в работу</b-dropdown-item
          >
          <b-dropdown-item
            v-if="isAdmin"
            :disabled="ticket.get_status.ID === 3"
            @click="setStatusTicket(3)"
            >Отклонить</b-dropdown-item
          >
          <b-dropdown-item
            :disabled="ticket.get_status.ID === 4"
            @click="setStatusTicket(4)"
            >Завершить</b-dropdown-item
          >
          <b-dropdown-divider v-if="permissionToDelete"></b-dropdown-divider>
          <b-dropdown-item v-if="permissionToDelete" @click="deleteTicket(ticket.ID)"
            >Удалить</b-dropdown-item
          >
        </b-dropdown>
        <b-icon-x @click="hide" class="ml-3 cursor-pointer"></b-icon-x>
      </h3>
    </template>

    <template #default>
      <div class="bg-white p-3">
        <TicketCardActions class="mb-4" />
        <TicketCardDetail />
      </div>
      <TicketCardComment class="mt-auto p-3" />
    </template>
    <template #footer>
      <CommentSubmitForm :loading="loading.comment" @submit="createComment" />
    </template>
  </b-sidebar>
</template>

<script>
import { HOST_FOR_STORAGE } from "@/constants";
import { mapActions, mapGetters, mapMutations } from "vuex";

import TicketCardComment from "@components/ticket/TicketCardComment.vue";
import TicketCardActions from "@components/ticket/TicketCardActions.vue";
import TicketCardDetail from "@components/ticket/TicketCardDetail.vue";
import CommentSubmitForm from "@components/comments/CommentSubmitForm.vue";

export default {
  components: {
    TicketCardComment,
    TicketCardActions,
    TicketCardDetail,
    CommentSubmitForm,
  },
  data() {
    return {
      hfs: HOST_FOR_STORAGE,
    };
  },

  computed: {
    ...mapGetters("tickets", ["ticket", "loading", "ticketOpen"]),
    ...mapGetters('auth' , ['currentUser']),

    isB2BTask() {
        return this.ticket.B2B_USER_ID !== 0
    },

    permissionToDelete () {
        return this.isAdmin || this.currentUser.id === this.ticket.B2B_USER_ID
    },

    ticketTitle() {
      return `Тема: ${this.ticket.TITLE}`;
    },

    isNotEmptyDocuments() {
      return !_.isEmpty(this.ticket.documents);
    },

    isAdmin() {
      return this.currentUser.role.includes("administrator");
    },

    showButtons() {
      return this.ticket.get_status.ID === (1 || 2);
    },

    variantBadge() {
      switch (this.ticket.get_status.ID) {
        case 1:
          return "info";
        case 2:
          return "warning";
        case 3:
          return "danger";
        case 4:
          return "success";
        default:
          return "info";
      }
    }
  },

  methods: {
    ...mapActions("tickets", [
      "fetchTicket",
      "createComment",
      "setStatusTicket",
      "deleteTicket",
    ]),

    ...mapMutations("tickets", ["RESET_TICKET"]),
  },
};
</script>
